const fetch = require('node-fetch')

module.exports = async function lookup(data) {
  return fetch(`${process.env.GATSBY_GATEWAY_API}/auth/lookup`, {
    method: 'POST',
    headers: {
      'Authorization' : encodeURIComponent(window.oAuth.access_token),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ email: data.email, phone_number: data.phone_number })
  }).then(res => res.json()).then(res => {
    return res
  }).catch(err => {
    console.log('Error', err)
  })
}
